import { Partner } from '@/entities/partner';
import { ImageShape } from '@/shared/lib/types';
import { axiosAPI } from './axios-instance';
import { ApiRequestFnParams, ApiResponse } from './lib/types';

export type ApiCompaniesRequest = {
    categories: number[];
};

export type ApiCompaniesResponse = ApiResponse<
    {
        id: number;
        slug: string;
        name: string;
        category_id: number;
        description?: string;
        link?: string;
        logo: ImageShape;
        main_logo?: ImageShape;
    }[]
>;

export type AppCompaniesResponse = ApiResponse<Partner[]>;

const transformApiResponse = (response: ApiCompaniesResponse): AppCompaniesResponse => {
    return {
        ...response,
        data: (response.data ?? []).map((item) => ({
            logo: item.logo,
            mainLogo: item.main_logo || null,
            title: item.name,
            description: item.description || '',
            href: item.link || '',
            categoryId: item.category_id,
        })),
    };
};

export const getCompanies = ({ params }: ApiRequestFnParams<ApiCompaniesRequest> = {}): Promise<AppCompaniesResponse> =>
    axiosAPI.get<ApiCompaniesResponse>('/v1/companies', { params }).then((res) => transformApiResponse(res.data));
